import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AddCardOutlinedIcon from '@mui/icons-material/AddCardOutlined';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';

// Global styling matrix defining a modern, unified layout list item track
const ModernBillingRowButton = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '18px 24px',
    backgroundColor: '#FFFFFF',
    textDecoration: 'none',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    cursor: 'pointer',
    '&:not(:last-child)': {
        borderBottom: '1px solid #F1F5F9'
    },
    '&:hover': {
        backgroundColor: '#F8FAFC',
        '& .modern-icon-badge': {
            color: '#1976d2',
            transform: 'scale(1.05)'
        },
        '& .modern-arrow': {
            color: '#0F172A',
            transform: 'translateX(4px)'
        }
    }
}));

const BillingPage = () => {
    const profile = useSelector(state => state.auth);
    
    return (
        <Box sx={{ width: '100%', boxSizing: 'border-box', p: 2.5 }}>
            
            {/* Core Framing Modern Surface */}
            <Card 
                className="sc--cardhead--details"
                sx={{ 
                    width: '100%',
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E2E8F0',
                    borderRadius: '16px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.03), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                    overflow: 'hidden'
                }}
            >
                <CardHeader 
                    title={
                        <Typography variant="h6" component="h1" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '15px', letterSpacing: '-0.3px', m: 0 }}>
                            Billing Control Panel
                        </Typography>
                    } 
                    sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                />
                
                <Divider sx={{ borderColor: '#E2E8F0' }} />
                
                <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                    <Box sx={{ width: '100%' }}>
                        
                        {/* Row Navigation Module 1: Core Payment Coordinates */}
                        <ModernBillingRowButton component={Link} to="/settings/payment">
                            <Stack direction="row" spacing={2.5} alignItems="center">
                                <AddCardOutlinedIcon 
                                    className="modern-icon-badge" 
                                    sx={{ fontSize: '20px', color: '#64748B', transition: 'all 0.15s ease-in-out' }} 
                                />
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1E293B', fontSize: '13.5px', letterSpacing: '-0.1px' }}>
                                    Billing & Payment Method
                                </Typography>
                            </Stack>
                            <ArrowForwardIcon 
                                className="modern-arrow" 
                                sx={{ color: '#94A3B8', fontSize: '16px', transition: 'all 0.15s ease-in-out' }} 
                            />
                        </ModernBillingRowButton>

                        {/* Row Navigation Module 2: Invoices Archive */}
                        {(profile && profile.profile && profile.profile.hide_rate === false || typeof profile.profile.hide_rate == "undefined") && (
                            <ModernBillingRowButton component={Link} to="/settings/invoices">
                                <Stack direction="row" spacing={2.5} alignItems="center">
                                    <ReceiptIcon 
                                        className="modern-icon-badge" 
                                        sx={{ fontSize: '20px', color: '#64748B', transition: 'all 0.15s ease-in-out' }} 
                                    />
                                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1E293B', fontSize: '13.5px', letterSpacing: '-0.1px' }}>
                                        Invoices
                                    </Typography>
                                </Stack>
                                <ArrowForwardIcon 
                                    className="modern-arrow" 
                                    sx={{ color: '#94A3B8', fontSize: '16px', transition: 'all 0.15s ease-in-out' }} 
                                />
                            </ModernBillingRowButton>
                        )}

                        {/* Row Navigation Module 3: Preferences Engine Map */}
                        <ModernBillingRowButton component={Link} to="/settings/invoice-settings">
                            <Stack direction="row" spacing={2.5} alignItems="center">
                                <SettingsApplicationsIcon 
                                    className="modern-icon-badge" 
                                    sx={{ fontSize: '20px', color: '#64748B', transition: 'all 0.15s ease-in-out' }} 
                                />
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1E293B', fontSize: '13.5px', letterSpacing: '-0.1px' }}>
                                    Invoice Settings
                                </Typography>
                            </Stack>
                            <ArrowForwardIcon 
                                className="modern-arrow" 
                                sx={{ color: '#94A3B8', fontSize: '16px', transition: 'all 0.15s ease-in-out' }} 
                            />
                        </ModernBillingRowButton>

                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

export default BillingPage;